module.exports = __webpack_public_path__ + "img/ventureburn-grey.4c3c5fe6.jpg";